import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Pillar2ComplianceLegendsComponent} from './components/sidenotes/pillar2-compliance-legends/pillar2-compliance-legends.component';
import {Pillar2ComplianceDynamicComponentHelper} from './pillar2-compliance-dynamic-component-helper';
import {SharedModule} from '@shared/shared.module';
import {TaskManagerModule} from '@features/task-manager/task-manager.module';

@NgModule({
  declarations: [
    Pillar2ComplianceLegendsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TaskManagerModule
  ],
  exports: [
    Pillar2ComplianceLegendsComponent
  ]
})
export class Pillar2ComplianceModule {
  constructor() {
    Pillar2ComplianceDynamicComponentHelper.init();
  }
}
